import PropTypes from 'prop-types'
import {
  DropdownLabelContainer,
  DropdownLabelText
} from '../styled-components'

const DropdownLabel = ({
  label,
  labelText,
  showLabel,
  disabled,
  readOnly
}) => {
  if (!label) return null

  return (
    <DropdownLabelContainer>
      <DropdownLabelText
        data-disabled={disabled}
        data-read-only={readOnly}
        style={{ opacity: showLabel ? '1' : '0' }}
      >
        {labelText}
      </DropdownLabelText>
    </DropdownLabelContainer>
  )
}

DropdownLabel.propTypes = {
  label: PropTypes.string,
  labelText: PropTypes.string,
  showLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool
}

export default DropdownLabel
